import { useRouter } from "next/router"
import { useEffect, useState } from "react"
import { Breadcrumb } from "@components/anti/Breadcrumb"
import { Cover } from "@components/anti/Cover"
import Link from "@components/anti/Link"
import { linkInvestorProspectus } from "src/helper/page-url"
import { translations } from "src/helper/translations"
import { useScrollAnim } from "src/hooks/hooks"
import Select from "@components/anti/Forms/components/select"
import { useGeneralStore } from "store"
import { investorsAreaList } from "./investors-area-list"
import { governanceList } from "./governance-list"

function InvestorsAreaGovernanceLayout({
  pageName,
  coverTitle,
  breadcrumb,
  children,
  type,
}) {
  const router = useRouter()
  const { locale, asPath } = router
  const { listInvestors, listGovernance } = useGeneralStore((state) => state)
  const [trigger, anim] = useScrollAnim()
  const listMenu =
    type === "investor"
      ? listInvestors?.length
        ? listInvestors
        : investorsAreaList
      : listGovernance?.length
      ? listGovernance
      : governanceList
  const [pageActive, setPageActive] = useState()
  useEffect(() => {
    const findItem = listMenu?.find(
      (item) => asPath.includes(item.link) || asPath.includes(item.parent)
    )
    if (findItem) {
      setPageActive({
        label: findItem[`title_${locale}`],
        value: findItem?.link,
      })
    }
  }, [asPath, listMenu, locale])
  return (
    <div className={`sc-investors-area-governance-layout ${type} ${pageName}`}>
      <section className="sc-investors-area-governance-cover" ref={trigger}>
        <Cover
          img="/img/bg/img_bg-contact-cover-mobile.png"
          imgMd="/img/bg/img_bg-contact-cover.png"
          imgHeight="h-250px h-md-400px"
          title={
            type === "investor"
              ? translations[`investors_area_${locale}`]
              : translations[`governance_${locale}`]
          }
          titleClassName="contact-title"
          text=""
          breadcrumb={<Breadcrumb path={breadcrumb} theme="dark" />}
        />
      </section>
      <section className="sc-investors-area-governance-content">
        <div className="cinema-gradient" />
        <div className="d-block d-lg-none">
          <Select
            variant="underline"
            options={listMenu?.map((item) => ({
              label: item[`title_${locale}`],
              value: item.link,
            }))}
            value={pageActive}
            className="list-menu__mobile"
            onChange={(_, e) => router.push(e.value)}
          />
        </div>
        <div className="container py-main">
          <div className="row w-100 mx-0">
            <div className="col-lg-3 col-menu d-none d-lg-block">
              <ul className="menu-list">
                {listMenu?.map((item, i) => (
                  <li
                    key={`menu-list__item-${i}`}
                    className={`menu-list__item ${
                      asPath.includes(item.link) ||
                      asPath.includes(item?.parent)
                        ? "is-active"
                        : ""
                    }`}
                  >
                    <Link href={item.link} scroll={false}>
                      {item[`title_${locale}`]}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-lg-9 col-content">
              <h1 className="mb-lg-5">{coverTitle}</h1>
              {children}
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default InvestorsAreaGovernanceLayout
